import { Dimensions, Platform, StyleSheet } from "../../core";
const columnTableStyles = StyleSheet.create({
  container: {
    marginBottom: 16,
    backgroundColor: "#fff",
    minHeight: "100%",
  },
  table: {
    borderStyle: "solid",
    borderColor: "#e2e2e2",
    borderBottom: 0,
    padding: 0,
    marginTop: 2,
    marginRight: 0,
    marginLeft: 0,
    // marginBottom: 75
    height: Platform.OS !== 'web' ? Dimensions.get('window').height - 250 : '100%',
  },
  borderWidth0: {
    borderWidth: 0
  },
  payNowBtnTxt: {
    top: 2,
  },
  tr: {
    position: "relative",
    paddingTop: 10,
    paddingRight: 16,
    paddingBottom: 10,
    paddingLeft: 16,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    flexDirection: "column",
  },
  td: {
    flex: 1,
    maxWidth: "100%",
    flexDirection: "column",
    height: 15,
  },
  flatListEle: {
    display: "block",
  },
  billListComponent: {
    backgroundColor: "#fff",
    paddingTop: 0,
    paddingRight: 0,
    paddingLeft: 0,
    position: 'relative',
    marginTop: 150,
    marginRight: 0,
    marginBottom: 30,
    marginLeft: 0,
    paddingBottom: 0,
  },
  noItemsTable: {
    height: "85%",
    paddingLeft: 16,
    paddingRight: 16,
  },
  noItemsComponent: {
    backgroundColor: "#fff",
    padding: 0,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#e2e2e2",
    marginLeft: 0,
    marginTop: 145,
    marginBottom: 0,
    marginRight: 0,
  },
  flexRowWithBorder: {
    flex: 1,
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottom: "solid",
    borderColor: "#dadada",
  },
  marginLeft0: {
    marginLeft: 0,
  },
  mViewIconContainer: {
    maxWidth: 24,
    marginLeft: 16,
    marginTop: 5,
    flexDirection: "row",
    flex: 1,
  },
  cellText: {
    fontSize: 11,
    wordBreak: 'break-word',
    color: "#182832",
    height: 15
  },
  btnHeight: {
    maxHeight: 20,
    zIndex: 2
  },
  firstColumnCellWidth: {
    width: "60%",
    minWidth: "60%",
    maxWidth: "60%",
    marginTop: -5,
  },
  secondColumnCellWidth: {
    width: "40%",
    minWidth: "40%",
    maxWidth: "40%"
  },
  statusCircle: {
    borderWidth: 5,
    borderStyle: "solid",
    borderRadius: 15,
    maxWidth: 5,
    maxHeight: 5,
    marginRight: 7,
  },

});

export { columnTableStyles };